







import { Vue, Component } from "@/shared/vuepack";

@Component
export default class AvidiaFooterCash extends Vue {
}
